import Icon from "../Icon/Icon";
import { cn } from "@/shared/utils/cn";

const variantSizes = {
  small: "2.1rem",
  medium: "2.7rem",
  large: "3rem",
  xLarge: "3.2rem",
};

const iconClassBySize: Record<keyof typeof variantSizes, string> = {
  small: "h-[1.2rem] w-[1.2rem]",
  medium: "h-[1.6rem] w-[1.6rem]",
  large: "h-[1.8rem] w-[1.8rem]",
  xLarge: "h-8 w-8",
};

export const DeleteIcon = ({
  size = "medium",
  ...props
}: {
  size: keyof typeof variantSizes;
}) => {
  return (
    <div
      className="inline-flex items-center bg-error cursor-pointer justify-center rounded-full"
      style={{ width: variantSizes[size], height: variantSizes[size] }}
      {...props}
    >
      <Icon
        className={cn("fill-white", iconClassBySize[size])}
        variants="times"
      />
    </div>
  );
};
